const TRUST_PREFIX = '@trust'
export const TRUST_LOCALE_KEY = `${TRUST_PREFIX}/locale`
export const TRUST_AUTH_TOKENS_KEY = `${TRUST_PREFIX}/auth-tokens`
